/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum QuizQuestionAnswerViewAliases {
  DYNAMIC_FIELDS_FETCH_QUIZ_QUESTION_ANSWER_VIEW = 'dynamic-fields-fetch-quiz-question-answer-view',
  FORM_FETCH_QUIZ_QUESTION_ANSWER_VIEW = 'form-fetch-quiz-question-answer-view',
  PANEL_QUIZ = 'panel-quiz',
  QUIZ_QUESTION_ANSWER_VIEW_LAYOUT = 'quiz-question-answer-view-layout',
}
export { QuizQuestionAnswerViewAliases };
